"use strict";

import { commonConstants, leaseConstants } from "../_constants";
import { portfolioConstants } from "../_constants/portfolio.constants";

const INITIAL_ACCOUNT_SUMMARY_DATA_STATE = {
  accountSummaryList: [],
  liabilitySummaryList: [],
  isAccountSummaryListLoading: false,
  tabType: portfolioConstants.ASSETS_SUMMERY,
};

export function myPortfolio(
  state = INITIAL_ACCOUNT_SUMMARY_DATA_STATE,
  action,
) {
  switch (action.type) {
    case portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_REQUEST:
      const requestAccountType = action?.payload?.accountType;
      return {
        ...state,
        isAccountSummaryListLoading: true,
        // Clear the opposite list when requesting new data
        ...(requestAccountType === portfolioConstants.ASSETS_SUMMERY
          ? { liabilitySummaryList: [] }
          : { accountSummaryList: [] }),
        tabType: requestAccountType,
      };
    case portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_COMPLETE:
      // Use accountType from action payload to avoid race conditions
      const accountType = action.payload?.accountType || state.tabType;
      
      // Only set loading to false and update tabType if this completion matches the current requested tabType
      // This prevents race conditions when both APIs are called simultaneously
      const shouldSetLoadingFalse = accountType === state.tabType;
      
      switch (accountType) {
        case portfolioConstants.ASSETS_SUMMERY:
          return {
            ...state,
            isAccountSummaryListLoading: shouldSetLoadingFalse ? false : state.isAccountSummaryListLoading,
            accountSummaryList: action.payload?.data,
            // Only update tabType if this matches the current request
            tabType: shouldSetLoadingFalse ? accountType : state.tabType,
          };

        case portfolioConstants.LIABILITY_SUMMERY:
          return {
            ...state,
            isAccountSummaryListLoading: shouldSetLoadingFalse ? false : state.isAccountSummaryListLoading,
            liabilitySummaryList: action?.payload?.data,
            // Only update tabType if this matches the current request
            tabType: shouldSetLoadingFalse ? accountType : state.tabType,
          };

        case portfolioConstants.LOAN_SUMMERY:
        case portfolioConstants.FIXED_DEPOSIT_SUMMERY:
        case portfolioConstants.SAVING_SUMMERY:
        case portfolioConstants.CURRENT_SUMMERY:
        case portfolioConstants.CREDIT_CARD_SUMMERY:
        case leaseConstants.LEASE_SUMMERY:
          return {
            ...state,
            isAccountSummaryListLoading: false,
            accountSummaryList: action.payload?.data,
            tabType: accountType,
          };

        default:
          return {
            ...state,
            isAccountSummaryListLoading: false,
          };
      }

    case portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_ERROR:
      // Determine which list to clear based on the last requested tabType
      const errorAccountType = state.tabType;
      if (errorAccountType === portfolioConstants.ASSETS_SUMMERY) {
        return {
          ...state,
          isAccountSummaryListLoading: false,
          accountSummaryList: [],
          // Keep liabilitySummaryList intact
        };
      } else if (errorAccountType === portfolioConstants.LIABILITY_SUMMERY) {
        return {
          ...state,
          isAccountSummaryListLoading: false,
          liabilitySummaryList: [],
          // Keep accountSummaryList intact
        };
      } else if (errorAccountType === portfolioConstants.LOAN_SUMMERY || errorAccountType === portfolioConstants.FIXED_DEPOSIT_SUMMERY || errorAccountType === portfolioConstants.SAVING_SUMMERY || errorAccountType === portfolioConstants.CURRENT_SUMMERY || errorAccountType === portfolioConstants.CREDIT_CARD_SUMMERY || errorAccountType === leaseConstants.LEASE_SUMMERY) {
        return {
          ...state,
          isAccountSummaryListLoading: false,
          accountSummaryList: [],
          // Keep accountSummaryList intact
        };
      }
      // Fallback: clear both if tabType is unknown
      return {
        ...state,
        isAccountSummaryListLoading: false,
        accountSummaryList: [],
        liabilitySummaryList: [],
      };

    case portfolioConstants.CLEAR_PORTFOLIO_DATA:
      return {
        ...state,
        isAccountSummaryListLoading: false,
        accountSummaryList: [],
        liabilitySummaryList: [],
      };
  }
  return state;
}
